import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseJwt } from "../utilities/utils";
import { useLogoutMutation } from "../../services/loginservices";
import { setCookie } from "../utilities/cookieUtils";
export const NotFound = () => {
    const [secondsLeft, setSecondsLeft] = useState(15);
  const[logoutApi]= useLogoutMutation()
  useEffect(() => {
    const countdown = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 0) {
          clearInterval(countdown);
          handleLogout(); // Call logout API
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
 
    return () => clearInterval(countdown);
  }, []);

  const logout = () => {
    // logoutAuthContext()
    localStorage.clear()
    // window.location.replace("https://demoecinet.eci.gov.in/logout");
    window.location.href = "/";
  };
 
  const handleLogout = async () => {
    setCookie("XUSRLGLK",'true')
    try {
    logoutApi(
       {
         userName : parseJwt(localStorage.getItem("access_token")).preferred_username, 
         id : parseJwt(localStorage.getItem("access_token")).session_state
       }
     ).then((res)=>{
        setTimeout(logout, 1 * 1080);
     })
    } catch (error) {
        setTimeout(logout, 1 * 1080);
    }
  };

    return(
        <div style={{
            textAlign: 'center',
            marginTop: '100px',
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#fff3f3',
            padding: '30px',
            border: '1px solid #f5c6cb',
            borderRadius: '10px',
            maxWidth: '500px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom:'auto',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
          }}>
            <p style={{ color: '#721c24', fontSize: '22px', fontWeight: 'bold' }}>
              You are not authorized to access this portal.
            </p>
            <p style={{ color: '#721c24', fontSize: '18px' }}>
              The system will log you out in <span style={{ fontWeight: 'bold' }}>{secondsLeft}</span> second{secondsLeft !== 1 ? 's' : ''}.
            </p>
          </div>
        );
}